<template>
    <nav ref="headerNavbar" class="header-navbar">
        <div class="header-navbar__container">
            <div class="header-navbar__row">
                <!--Le logo-->
                <a :href="brand.url" class="header-navbar__logo">
                    <!--<img :src="brand.imageUrl" width="95" height="45" class="" alt="RTD logo">-->
                    <svg class="logo-svg" xmlns="http://www.w3.org/2000/svg" width="95" height="45" viewBox="0 0 95 45">
                        <g fill="none" fill-rule="evenodd" transform="translate(-29 -34)">
                            <rect width="94" height="3" x="29" y="76" class="logo-svg__line" />
                            <path class="logo-svg__path" fill-rule="nonzero" d="M29,50.0201511 C29,45.4055416 29,40.790932 29,36.1763224 C29,34.9874055 29.9694788,34 31.2277385,34 C37.9109538,34 44.573542,34 51.2567573,34 C52.0612184,34 52.8244251,34.2015113 53.5670046,34.5037783 C54.3095841,34.8060453 54.9696547,35.209068 55.5472166,35.7329975 C56.8673579,36.8816121 57.6511918,38.3526448 58.0843631,40.0050378 C58.373144,41.1133501 58.4143984,42.2216625 58.3525168,43.3501259 C58.270008,44.6196474 57.9812271,45.8488665 57.4655469,47.0377834 C57.0117483,48.0856423 56.4341865,49.0730479 55.691607,49.9395466 C54.7840099,51.0075567 53.7320223,51.9143577 52.3912537,52.4584383 C51.9580824,52.6397985 51.4836566,52.7607053 51.029858,52.861461 C50.1841425,53.02267 49.7509711,53.6473552 49.6890895,54.372796 C49.6478351,54.8967254 49.9159888,55.3400504 50.3697874,55.6221662 C51.3598933,56.2267003 52.3499993,56.8312343 53.3401053,57.4357683 C54.1858208,57.9596977 55.0521636,58.4836272 55.8978791,58.9874055 C57.1355116,59.7329975 58.3937712,60.4785894 59.6314037,61.2443325 C60.1470839,61.5667506 60.6421369,61.9496222 61.1165627,62.3123426 C61.3640892,62.4937028 61.5909885,62.7355164 61.7560061,62.97733 C61.9003966,63.1788413 61.9622782,63.4609572 61.9829054,63.7027708 C62.0241598,64.1662469 62.0035326,64.6297229 61.7766333,65.0730479 C61.5084796,65.5566751 61.0959355,65.7984887 60.5802553,65.8992443 C60.1883383,65.9798489 59.7964214,66 59.4045044,66 C55.5059621,66 51.6074198,66 47.7088776,66 C46.7187716,66 45.7492928,65.2745592 45.5842751,64.2468514 C45.5636479,64.1057935 45.5430207,63.9647355 45.5430207,63.8438287 C45.5430207,55.3803526 45.5430207,46.9168766 45.5430207,38.4534005 C45.5430207,37.7078086 45.0892222,37.0428212 44.3672699,36.9017632 C43.9753529,36.8211587 43.6040632,36.9017632 43.2740279,37.1032746 C41.5825968,38.1108312 39.8911658,39.0982368 38.1997347,40.1057935 C36.6526941,41.0327456 35.1056535,41.9596977 33.5586129,42.8866499 C33.269832,43.0680101 32.9604239,43.2292191 32.671643,43.4105793 C32.1559628,43.7329975 32.073454,44.1561713 32.2797261,44.720403 C32.3828621,45.02267 32.6510158,45.1234257 32.8779151,45.2644836 C33.8061394,45.8287154 34.7343638,46.3929471 35.6625881,46.9370277 C36.9208478,47.7027708 38.1791075,48.4483627 39.4373672,49.2141058 C40.2624555,49.7178841 41.1287982,50.1813602 41.9332593,50.7455919 C42.6552116,51.2695214 43.191519,51.9546599 43.191519,52.9017632 C43.2121462,56.5491184 43.2327734,60.1964736 43.2327734,63.8236776 C43.2327734,64.9319899 42.5520756,65.7984887 41.3144431,66 C41.2525615,66 41.1906799,66 41.1287982,66 C37.8078178,66 34.5074645,66 31.186484,66 C30.1344964,66 29.1650177,65.1738035 29.0412544,64.1662469 C29.0206272,63.9848866 29,63.8236776 29,63.6423174 C29,59.1284635 29,54.5743073 29,50.0201511 Z M94.0411197,50.0025122 C94.0411197,45.3801225 94.0411197,40.7778301 94.0411197,36.1554404 C94.0411197,35.029989 95.0485523,34.0050243 96.2204637,34.0050243 C100.270754,34.0050243 104.300484,33.984927 108.350774,34.0251217 C109.214288,34.0251217 110.077802,34.1859005 110.941315,34.3466792 C111.887068,34.5275553 112.812262,34.8089182 113.716895,35.1505731 C114.662648,35.5324227 115.567281,35.9745643 116.430795,36.4970953 C117.664386,37.2607945 118.774618,38.1852724 119.761491,39.2303344 C120.481085,39.9940336 121.139,40.8381222 121.673556,41.7425027 C122.352031,42.8880515 122.948267,44.0737949 123.297785,45.3600251 C123.523943,46.1438216 123.688422,46.9678128 123.832341,47.7717067 C123.93514,48.3545298 123.9557,48.9574501 123.97626,49.5402732 C123.996819,50.0628042 124.017379,50.6054326 123.97626,51.1480609 C123.87346,52.4543884 123.647302,53.7406186 123.256665,54.9866541 C122.927707,56.0719108 122.49595,57.1169728 121.940835,58.1218402 C121.467958,58.9860261 120.933402,59.8301146 120.275487,60.5737164 C120.131568,60.7344952 119.987649,60.895274 119.82317,61.0560528 C119.514772,61.3374156 119.144695,61.3374156 118.795178,61.2168315 C118.363421,61.0560528 117.952224,60.8148846 117.561587,60.5938138 C116.595274,60.0109907 115.628961,59.4281677 114.662648,58.8453446 C113.922493,58.403203 113.182339,57.9610614 112.442184,57.5189198 C112.113227,57.3179463 112.030987,56.9762914 111.969308,56.6346365 C111.969308,56.5743445 111.969308,56.5341498 111.969308,56.4738577 C111.969308,50.5451405 111.969308,44.596326 111.969308,38.6676087 C111.969308,38.1651751 111.866509,37.6627414 111.475871,37.2808918 C111.085234,36.8990422 110.118921,36.7583608 109.687165,37.2808918 C109.214288,37.8637149 108.700292,38.4063432 108.206856,38.9489716 C107.857338,39.3509185 107.487261,39.7327681 107.137743,40.134715 C106.685427,40.657246 106.23311,41.179777 105.760234,41.6822107 C105.431276,42.0640603 105.081758,42.4258125 104.752801,42.8076621 C104.279924,43.3301931 103.827608,43.8527241 103.375291,44.3752551 C103.046333,44.7571047 102.696816,45.118857 102.367858,45.5007065 C101.894982,46.0232376 101.442665,46.5658659 100.969789,47.0883969 C100.620271,47.4702465 100.270754,47.8520961 99.9212365,48.254043 C99.4278001,48.8167687 98.9138039,49.3593971 98.4614872,49.9623175 C97.8446917,50.746114 98.214769,51.5299105 98.9343637,51.9720521 C99.9417963,52.5950699 100.949229,53.1979903 101.956661,53.8009107 C103.149133,54.5244151 104.341604,55.2278223 105.534075,55.9513267 C106.418149,56.4939551 107.302222,57.0164861 108.206856,57.5591145 C109.296527,58.2223269 110.386199,58.865442 111.475871,59.5286544 C112.298265,60.0310881 113.120659,60.5134244 113.922493,61.0158581 C114.559849,61.3977076 115.176644,61.7996546 115.814,62.1614068 C116.739193,62.7040352 116.595274,63.6486105 115.875679,64.1108494 C114.683208,64.8946459 113.387937,65.3970796 111.989868,65.6382478 C111.311393,65.7588318 110.612358,65.8593186 109.913323,65.8995133 C109.070369,65.9598053 108.227415,65.9799027 107.405021,66 C103.683689,66 99.9623561,66 96.2204637,66 C95.0279924,66 94,64.9750353 94,63.8495839 C94.0411197,59.2271942 94.0411197,54.6048045 94.0411197,50.0025122 Z M75.5255318,34 C79.9813794,34 84.4172456,34 88.8730932,34 C89.8521808,34 90.7113801,34.6834171 90.9511566,35.6482412 C90.9911194,35.7889447 90.9911194,35.9296482 90.9911194,36.0502513 C90.9911194,38.5226131 91.0111008,40.9748744 90.9911194,43.4472362 C90.9911194,44.2512563 90.6714173,44.9748744 89.9520877,45.4371859 C89.7522739,45.5577889 89.4925159,45.6180905 89.232758,45.6582915 C88.7931677,45.6984925 88.3335959,45.678392 87.9339683,45.4773869 C87.5942849,45.2964824 87.2546014,45.0753769 86.9348994,44.8743719 C85.7759794,44.1507538 84.597078,43.4271357 83.438158,42.7035176 C82.7987538,42.3015075 82.1793311,41.879397 81.5199456,41.5376884 C80.7606532,41.1356784 79.7615842,41.3768844 79.541789,42.4221106 C79.5018263,42.6231156 79.5018263,42.8040201 79.5018263,43.0050251 C79.5018263,49.959799 79.5018263,56.9346734 79.5018263,63.8894472 C79.5018263,64.8140704 78.962329,65.6582915 78.0232042,65.919598 C77.8633531,65.959799 77.7035021,66 77.5636325,66 C75.4655876,66 73.3475614,66 71.2495166,66 C70.2904104,66 69.3712669,65.3165829 69.1514717,64.2914573 C69.1314904,64.1507538 69.111509,64.0100503 69.111509,63.8894472 C69.111509,60.0904523 69.111509,56.2914573 69.111509,52.4924623 C69.111509,51.5477387 68.6919,50.8241206 67.8726635,50.3417085 C67.0334455,49.839196 66.214209,49.3165829 65.3949724,48.7939698 C64.4158848,48.1909548 63.4367972,47.5879397 62.477691,46.9849246 C61.9581752,46.6633166 61.4586407,46.3417085 60.9391248,46 C60.4595717,45.678392 60.2197952,45.1959799 60.1398697,44.6331658 C60.0799255,44.2512563 60.0599441,43.8492462 60.0399628,43.4472362 C60.0199814,41.0552764 60,38.6633166 60,36.2713568 C60,35.0854271 60.7592924,34.2211055 61.898231,34.0201005 C61.9781566,34 62.0381007,34.0201005 62.1180262,34.0201005 C66.5938552,34 71.0696842,34 75.5255318,34 Z" />
                        </g>
                    </svg>

                </a>

                <div class="header-navbar__burger">
                    <burger-component @toggle="toggleNavbar" />
                </div>

                <div ref="navbar" class="header-navbar__navbar" :class="navClass + ' ' + iAmPro">
                    <slot />
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
import BurgerComponent from './BurgerComponent'

export default {
    name: 'HeaderComponent',
    components: {
        BurgerComponent
    },
    props: {
        brand: {
            type: Object,
            default: function () {
                return {
                    url: '',
                    imageUrl: ''
                }
            }
        }
    },
    data() {
        return {
            proTarget: true,
            iAmPro: 'null'
        }
    },

    computed: {
        navClass() {
            return this.proTarget !== false ? 'pro' : 'no-pro';
        }
    },

    created() {
        window.addEventListener('resize', this.onResize)
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.onResize)
    },

    mounted() {
        const iAmPro = localStorage.getItem('i-am-pro') || null;
        this.iAmPro = iAmPro;
        this.proTarget = iAmPro !== 'false';

        document.querySelector('.footer__row').classList.add(this.navClass);

        if (this.navClass === 'no-pro') {
            document.querySelector('.breadcrumb').classList.remove('d-md-block');
            document.querySelector('.header-navbar__logo').removeAttribute('href');
        }
    },

    methods: {
        toggleNavbar() {
            this.$refs.navbar.classList.toggle('is-active');
            this.$refs.headerNavbar.classList.toggle('is-active');
        },
        onResize() {
            if (window.innerWidth >= 992) {
                this.$refs.navbar.classList.remove('is-active');
                this.$refs.headerNavbar.classList.remove('is-active');
            }
        }
    }
}
</script>

<style lang="scss">

   @import '~@/assets/styles/abstracts/variables';
    @import '~bootstrap/scss/mixins';
   @import '~@/assets/styles/vendor/override-bootstrap-mixins';

    svg {
        fill: $gray-800;
        transition: fill 300ms ease-out;
    }

    .header-navbar {

        $self: &;

        position: relative;
        background-color: $white;
        padding: 2.4rem 0;
        transition: background-color 300ms ease-out;
        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);

        /*-webkit-font-smoothing: subpixel-antialiased;
        -moz-osx-font-smoothing: auto;*/

        @include media-breakpoint-up(lg) {
            padding: 2.3rem 0 1.6rem;
            background-color: $white;
        }

        &.is-active {
            background-color: $gray-900;
            min-height: 100vh;

            .logo-svg__line,
            .logo-svg__path {
                fill: $white;
            }

        }

        &__container {
            @include make-container();
            //@include make-container-max-widths();
        }

        &__row {
            @include make-row();
        }

        &__logo {
            @include make-col-ready();
            @include media-breakpoint-up(lg) {
                flex: 0 0 auto;
                width: auto;
            }
        }

        &__burger {
            position: absolute;
            right: 0;
            top: 0;
            width: 80px;
            height: 80px;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 300ms ease-out;

            @include media-breakpoint-up(lg) {
                display: none;
            }
        }

        &__navbar {
            @include make-col-ready();

            text-align: center;
            display: none;

            @include media-breakpoint-up(lg) {
                display: flex;
                flex: 1;
                text-align: right;
                width: auto;
                align-items: baseline;
                justify-content: flex-end;
                flex-wrap: wrap;
            }

            &.is-active {
                display: block;
            }

            &.pro {
                & > .patient {
                    display: none;
                }
            }

            &.no-pro {
                & > .pro {
                    display: none;
                }
            }
        }

        &__item {
            color: $white;
            display: block;
            margin: 8vh 0;

            @include media-breakpoint-up(lg) {
                display: inline-block;
                color: #50565e;
                margin: 0.7rem 0;

                &:not(:first-child) {
                    margin-left: 4.2rem;
                }
            }

            &:hover {
                text-decoration: none;
            }

            &.is-active {
                color: $primary
            }

        }

        .logo-svg {
            //
            &__line {
                fill: #ffec55;
            }

            &__path {
                fill: #00326c;
            }
        }

    }
</style>
